import { Injectable } from '@angular/core';
import { LiveChatServiceInterface } from './live-chat-service.interface';
import { GenesysDxService } from './genesys-dx.service';
import { GenesysCxWebMessagingService } from './genesys-cx-web-messaging.service';
import { Observable } from 'rxjs';
import { GenesysDxApiService } from './genesys-dx-api.service';
import { LiveChatPlatform } from '../../types/enum';

@Injectable({
  providedIn: 'root',
})
export class LiveChatPlatformService {
  constructor(
    private genesysDxService: GenesysDxService,
    private genesysCxWebMessagingService: GenesysCxWebMessagingService,
    private genesysDxBackendService: GenesysDxApiService
  ) {}

  isDxPlatform(platform: string): boolean {
    return platform === LiveChatPlatform.dx;
  }

  getPlatformService(platform: string): LiveChatServiceInterface {
    if (this.isDxPlatform(platform)) {
      return this.genesysDxService;
    }
    return this.genesysCxWebMessagingService;
  }

  createLiveChat({
    departmentId = '',
    platform = '',
    firstName = '',
    lastName = '',
    language = 'en',
    sessionId = '',
  }): Observable<any> {
    if (platform === LiveChatPlatform.dx) {
      return this.genesysDxBackendService.createLiveChat({
        departmentId,
        platform,
        firstName,
        lastName,
        language,
        sessionId,
      });
    }
    return this.genesysCxWebMessagingService.createLiveChat();
  }
}
